<template>
  <div class="v-agents-manage">
    <b-card class="v-agents-manage__card">
      <div class="row v-agents-manage__card__header">
        <div class="col-6 text-right">
          <h3>مدیریت پشتیبان ها</h3>
        </div>
        <div class="col-6">
          <b-button size="sm" variant="primary" @click="modalShow = !modalShow"
            >اضافه کردن پشتیبان</b-button
          >
        </div>
      </div>

      <hr class="mt-3 mb-3" />

      <div class="row">
        <b-skeleton-table
          v-if="loading"
          :rows="5"
          :columns="5"
          :table-props="{ bordered: true, striped: true }"
        >
        </b-skeleton-table>

        <b-table
          v-else
          :items="agents"
          :fields="fields"
          empty-text="موردی یافت نشد"
          stacked="md"
          show-empty
          small
        >
          <template #cell(status)="row">
            <v-select
              :disabled="actionLoading"
              :components="{ Deselect }"
              :options="statusItems"
              :value="row.item.status"
              label="label"
              @input="(status) => changeStatus(row.item.id, status.id)"
            >
              <template #selected-option="{ label }">
                <div style="display: flex; align-items: baseline">
                  <strong>{{ label }}</strong>
                </div>
              </template>
              <template #option="{ label }">
                <div style="display: flex; align-items: baseline">
                  <strong>{{ label }}</strong>
                </div>
              </template>
            </v-select>
          </template>
          <template #cell(actions)="row">
            <b-button
              size="sm"
              :to="`/user-profile/${row.item.id}`"
              variant="primary"
              class="mr-1"
              target="_blank"
            >
              نمایش پروفایل کاربر
            </b-button>
            <b-button
              size="sm"
              @click="editAgent(row.item.id)"
              variant="primary"
              class="mr-1"
            >
              ویرایش
            </b-button>
          </template>
        </b-table>
      </div>
    </b-card>

    <b-modal
      v-model="modalShow"
      centered
      hide-header
      hide-footer
      modal-class="v-agents-manage__add-agent"
    >
      <div class="v-agents-manage__add-agent__header">
        <h3>اضافه کردن پشتیبان</h3>
        <hr class="mt-2 mb-2" />
      </div>

      <AddAgentForm
        @close="modalShow = false"
        @agentAdded="addedAgent()"
        @agentEdited="agentEdited()"
        :agentId="editAgentId"
      />
    </b-modal>
  </div>
</template>

<script>
import Agents from "@/httpservices/Agents";
import AddAgentForm from "@/components/AddAgentForm.vue";

export default {
  name: "AgentsManage",
  components: {
    AddAgentForm,
  },

  data() {
    return {
      Deselect: {
        render: (createElement) => createElement("span", ""),
      },
      agents: [],
      modalShow: false,
      loading: true,
      actionLoading: false,
      editAgentId: "",
      statusItems: [
        { id: "1", label: "فعال" },
        { id: "0", label: "غیر فعال" },
      ],

      fields: [
        {
          key: "name",
          label: "نام",
          sortable: true,
          class: "text-right",
        },
        {
          key: "mobile",
          label: "موبایل",
          sortable: true,
          class: "text-right",
        },
        {
          key: "status",
          label: "وضعیت",
          sortable: true,
          class: "text-right",
        },
        { key: "actions", label: "عملیات" },
      ],
    };
  },

  mounted() {
    this.getAgents();
  },

  watch: {
    modalShow() {
      if (this.modalShow === false) {
        this.editAgentId = "";
      }
    },
  },

  methods: {
    changeStatus(agentID, status) {
      this.actionLoading = true;

      Agents.changeStatus(agentID, status)
        .then(() => {
          this.getAgents();
        })
        .catch(() => {})
        .finally(() => {
          this.actionLoading = false;
        });
    },

    editAgent(id) {
      this.modalShow = true;
      this.isEdit = true;
      this.editAgentId = id;
    },

    getAgents() {
      Agents.getAgents()
        .then((response) => {
          this.agents = [];
          response.data.data.forEach((element) => {
            this.agents.push({
              id: element.id,
              mobile: element.mobile,
              name: element.name,
              status:
                element.status === "0"
                  ? { id: "0", label: "غیر فعال" }
                  : { id: "1", label: "فعال" },
            });
          });

          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    addedAgent() {
      this.getAgents();
      this.modalShow = false;

      this.$swal({
        position: "center",
        icon: "success",
        title: "پشتیبان جدید با موفقت اضافه شد",
        showConfirmButton: false,
        timer: 3000,
      });
    },

    agentEdited() {
      this.getAgents();
      this.modalShow = false;

      this.$swal({
        position: "center",
        icon: "success",
        title: "پشتیبان با موفقت ویرایش شد",
        showConfirmButton: false,
        timer: 3000,
      });
    },
  },
};
</script>

<style lang="scss">
.v-agents-manage {
  padding: 24px;

  table {
    direction: rtl;
    text-align: right;
  }

  &__add-agent {
    .modal-body {
      padding: 16px;
    }

    text-align: right;

    &__header {
      h1 {
      }
    }
  }
}
</style>
